import { type RequestBody } from '../http/type-helpers';

import { type SellerStatusResponse } from './types';

import {
  BILLING_AGREEMENT_SUBMISSION_ENDPOINT,
  BILLING_AGREEMENT_TOKEN_ENDPOINT,
  CREATE_STRIPE_USER_ENDPOINT,
  SELLER_STATUS_ENDPOINT,
  STRIPE_ELIGIBILITY_ENDPOINT,
} from '@/constants/endpoints';
import http, { typedHttp } from '@/modules/http';
import { type AxiosCompatibleResponse } from '@/modules/http/types';

export function fetchBillingAgreementToken() {
  return typedHttp.post(BILLING_AGREEMENT_TOKEN_ENDPOINT, null, {
    withAuth: true,
  });
}

export function updateBillingAgreement(
  params: RequestBody<typeof BILLING_AGREEMENT_SUBMISSION_ENDPOINT, 'put'>
) {
  return typedHttp.put(BILLING_AGREEMENT_SUBMISSION_ENDPOINT, params, {
    withAuth: true,
  });
}

export function createCustomStripeUser(
  body: RequestBody<typeof CREATE_STRIPE_USER_ENDPOINT>
) {
  return typedHttp.post(CREATE_STRIPE_USER_ENDPOINT, body, {
    withAuth: true,
  });
}

export function fetchSellerStatusApiRequest(): Promise<
  AxiosCompatibleResponse<SellerStatusResponse>
> {
  return http.get(SELLER_STATUS_ENDPOINT, { withAuth: true });
}

export function checkDepopPaymentsEligibility(
  body: RequestBody<typeof STRIPE_ELIGIBILITY_ENDPOINT>
) {
  return typedHttp.post(STRIPE_ELIGIBILITY_ENDPOINT, body, {
    withAuth: true,
  });
}
